export const CHANNEL_MAIN = 'crypkit_main'

export const EVENT_LOGGED_OUT = 'logged_out'
